// src/helper/responseFormatter.ts
export function toCamel<T>(input: any): T {
  if (Array.isArray(input)) {
    return input.map(i => toCamel(i)) as any;
  } else if (input !== null && typeof input === 'object') {
    return Object.entries(input).reduce((acc, [key, val]) => {
      const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
      (acc as any)[camelKey] = toCamel(val);
      return acc;
    }, {} as any) as T;
  } else {
    return input;
  }
}
